import { lang } from '@lib/constants'

export const formatPrice = (priceString: string) => {
	const num = parseFloat(priceString || '0')
	const hasDecimals = num % 1 !== 0
	return num.toLocaleString(lang, {
		minimumFractionDigits: hasDecimals ? 2 : 0,
		maximumFractionDigits: hasDecimals ? 2 : 0
	})
}

export const getCurrencySymbol = () => (lang === 'en-gb' ? '£' : '$')
